export const PopOverPreferPlaces = {
   below: 'below',
   left: 'left',
   above: 'above',
   right: 'right'
}
